<div mat-dialog-title>
    {{isAcademicHistory ? 'Academic History' : 'Saved'}} Layouts
</div>

<mat-dialog-content style="min-width:500px;">
    <span *ngIf="initialized && dataSource.data.length == 0">
        No Layouts Exist
    </span>
    <mat-table [dataSource]="dataSource" multiTemplateDataRows matSortDisableClear matSort id="savedlayoutTable"
        matSortActive="Name" matSortDirection="asc" aria-label="Saved Layouts Table"
        *ngIf="initialized && dataSource.data.length > 0">
        <ng-container matColumnDef="More">
            <mat-header-cell *matHeaderCellDef style="min-width:100px; max-width:100px;">
                More
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="min-width:100px; max-width:100px;">
                <span aria-label="Expand row for more details">
                    <i [ngClass]="dataSource.checkExpanded(element) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                        aria-hidden="true"></i>
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Name">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;">
                Name
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="min-width:150px;">
                {{element.Name}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Scope">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:140px; max-width:140px;">
                Scope
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="min-width:140px; max-width:140px;">
                {{element.Scope}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="OwnerName">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:160px; max-width:160px;">
                Owner
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="min-width:160px; max-width:160px;">
                {{element.OwnerName}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="LastUpOn">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:140px; max-width:140px;">
                Last Update
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="min-width:140px; max-width:140px;">
                {{element.LastUpOn | date: 'MM/dd/yy'}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef style="min-width:120px; max-width:120px;">
                Actions
            </mat-header-cell>
            <mat-cell *matCellDef="let element; let i = index;" style="min-width:120px; max-width:120px;">
                <tyl-mat-menu id="actionMenu{{i}}" image="actions.png" [iconWidth]="30">
                    <button id="duplicate{{i}}" mat-menu-item class="menuItem" (click)="duplicateClick(element)"
                        [disabled]="element.Owner != userId">Duplicate</button>
                    <button id="edit{{i}}" mat-menu-item class="menuItem" (click)="editClick(element)"
                        [disabled]="element.Owner != userId">Edit</button>
                    <button id="delete{{i}}" mat-menu-item class="menuItem" (click)="deleteClick(element)"
                        [disabled]="element.Owner != userId">Delete</button>
                </tyl-mat-menu>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length"
                style="display: flex;flex-direction: column;align-items:start;" class="mat-detail-card">
                <span class="label">Description</span>
                <span>{{element.Description}}</span>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>

        <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="dataRow{{i}}" tabindex="0"
            [ngStyle]="{'border-bottom-width':dataSource.checkExpanded(row) ? '0px' : '1px'}"
            style="padding:0px;overflow: hidden;" matRipple (click)="dataSource.toggleExpanded(row)">
        </mat-row>

        <mat-row *matRowDef="let row; columns: ['expandedDetail']"
            [@detailExpand]="dataSource.checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden;"
            class="mat-detail-row">
        </mat-row>
    </mat-table>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>
        <tyl-button image="add.png" label="Add Layout" (clickEvent)="addLayoutClick()"></tyl-button>
    </div>
    <div class='flex-footer-right'>
        <tyl-button image="cancel.png" label="Close" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>